import type { PersonaFormState, PersonaFormType } from '..';
import { MobxProps } from './useCommonState';
import SCIMBasedForm from './SCIMBasedForm';
import TitleBasedForm from './TitleBasedForm';
import type { PersonaRowData, PersonaToast } from 'admin/types';
import { mobxInjectSelect } from 'common/utils';

type PersonaFormProps = {
  setPersonaFormState: React.Dispatch<React.SetStateAction<PersonaFormState>>;
  selectedPersona?: PersonaRowData;
  setSelectedPersona: (persona: PersonaRowData | undefined) => void;
  editMode: boolean;
  setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  setToastMessageData: React.Dispatch<React.SetStateAction<PersonaToast | undefined>>;
  formType: PersonaFormType;
};

function PersonaForm({
  createPersona,
  editMode,
  findSCIMGroups,
  formType,
  isPersonaMessageTtlAndPinLockEnabled,
  loadTitles,
  selectedPersona,
  setEditMode,
  setPersonaFormState,
  setSelectedPersona,
  setToastMessageData,
  updatePersona,
}: PersonaFormProps & MobxProps) {
  return formType === 'title' ? (
    <TitleBasedForm
      selectedPersona={selectedPersona}
      setToastMessageData={setToastMessageData}
      setPersonaFormState={setPersonaFormState}
      editMode={editMode}
      isPersonaMessageTtlAndPinLockEnabled={isPersonaMessageTtlAndPinLockEnabled}
      loadTitles={loadTitles}
      setEditMode={setEditMode}
      setSelectedPersona={setSelectedPersona}
      createPersona={createPersona}
      updatePersona={updatePersona}
    />
  ) : (
    <SCIMBasedForm
      selectedPersona={selectedPersona}
      setToastMessageData={setToastMessageData}
      setPersonaFormState={setPersonaFormState}
      editMode={editMode}
      isPersonaMessageTtlAndPinLockEnabled={isPersonaMessageTtlAndPinLockEnabled}
      setEditMode={setEditMode}
      loadTitles={loadTitles}
      setSelectedPersona={setSelectedPersona}
      createPersona={createPersona}
      updatePersona={updatePersona}
      findSCIMGroups={findSCIMGroups}
    />
  );
}

export default mobxInjectSelect<PersonaFormProps, MobxProps>({
  messengerStore: ['isPersonaMessageTtlAndPinLockEnabled'],
  personaStore: ['createPersona', 'loadTitles', 'updatePersona'],
  scimStore: ['findSCIMGroups'],
})(PersonaForm);
